<ion-menu mode="md" side="start" menuId="first" contentId="main-content" [swipeGesture]="swipeGesture()">
  <ion-header class="ion-no-border">
    <ion-toolbar class="default-ion-styles">
      <div class="toolbar-content">
        <div class="toolbar-content__logo">
          <img alt="UVE" [src]="user()?.logo_url" />
        </div>
        <div class="toolbar-content__info">
          <div>UVE Solutions</div>

          <div class="open-user" [attr.data-qa-id]="'bttn-user'" (click)="openModalUser()">
            {{ 'user' | uvetranslate }}:
            <div class="open-user-color" [class.open-user-max-width-sm]="isMobile()">{{ user()?.userName }}</div>
          </div>
        </div>
      </div>

      @if (isMobile()) {
        <ion-buttons slot="end">
          <app-modal-close-button (close)="close()" />
        </ion-buttons>
      }
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-list class="menu-items">
      <ion-menu-toggle auto-hide="true">
        @for (pages of navigate(); track pages) {
          <!-- Router link item -->
          @if (((isMobile() && pages.mobile()) || (!isMobile() && pages.tablet())) && pages.url) {
            <ion-item
              class="menu-button"
              [attr.data-qa-id]="'menu-label'"
              [class.custom-item-disabled]="!isOnline() && pages.disableOffline()"
              [class.active-page]="currentUrl() === pages.url"
              (click)="goToSelectedPage(pages)">
              <ion-icon slot="start" class="menu-icon" [src]="pages.icon" />
              <ion-label [attr.data-qa-id]="'menu-label'">
                {{ pages.title | uvetranslate }}
              </ion-label>
            </ion-item>
          }
        }
      </ion-menu-toggle>
    </ion-list>
  </ion-content>

  <ion-footer class="ion-no-border">
    <ion-toolbar class="default-ion-styles">
      <div class="gear-icon" (click)="goToConfiguration()">
        <ion-icon src="assets/icon/gear-light.svg" slot="start" class="gear-icon" [attr.data-qa-id]="'configuration'" />
      </div>
    </ion-toolbar>
  </ion-footer>
</ion-menu>
